import React from "react";
import { Flex, Text } from "@fluentui/react-northstar";
import styled from "styled-components/macro";

const CellCategory = ({ category_name = "" }) => {
    if (!category_name) return null;
    return (
        <Wrapper title={category_name}>
            <CategoryText truncated content={category_name} />
        </Wrapper>
    );
};

export default CellCategory;

const Wrapper = styled(Flex)`
    border-radius: 4px;
    background: var(
        --Light-theme-Rest-Background-Default-Background-3,
        #f0f0f0
    );
    display: flex;
    height: 24px;
    padding: 4px 8px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    /* width: 130px; */
`;

const CategoryText = styled(Text)`
    color: var(
        --light-theme-rest-foreground-default-foreground-242424,
        #242424
    );
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
`;
